<template>
  <div>
    <el-tabs class="tab tabCon tabbor" type="card" @tab-click="handleTypeChange">
      <el-tab-pane label="全部"></el-tab-pane>
      <el-tab-pane label="未支付"></el-tab-pane>
      <el-tab-pane label="已支付"></el-tab-pane>
    </el-tabs>
    <div class="conBor bor">
      <el-table :data="tableData" stripe style="width: 100%" current-row-key="id">
        <el-table-column type="expand" class='table_con'>
          <template slot-scope="scope">
            <div style='text-align:left'>
              <div>
              姓名：<span >{{scope.row.signName}}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;身份证：<span >{{scope.row.signCard}}</span>
              </div>
              <div>
                <div v-if='scope.row.subjectLevelScore!=null'>
                  科目成绩：<span>{{scope.row.subjectLevelScore}}</span>
                </div>
                <div v-if='scope.row.theoryScore!=null'>
                  乐理成绩：<span>{{scope.row.theoryScore}}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signExam" label="编号" ></el-table-column>
        <el-table-column label="报名项目" >
          <template slot-scope="scope">
            <div v-if='scope.row.subName'>
              <div>
              专业级别：<span >{{scope.row.subName}}&nbsp;&nbsp;{{scope.row.subjectLevelName}}</span>
              </div>
            </div>
            <div v-if='scope.row.theoryName'>
              <div>
              乐理：<span >{{scope.row.theoryName}}</span>
              </div>
            </div>
            <div v-if='scope.row.signPayTutDtos.length>0'>
              辅导课：<span v-for='(TutDtos,index) in scope.row.signPayTutDtos' :key='index'>{{TutDtos.tutorialName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="signPrice" label="费用" ></el-table-column>
        <el-table-column label="座位信息" min-width="120px">
          <template slot-scope="scope">
            <div v-if="scope.row.seatNo">
                考场：
              {{scope.row.clsName}}
              <br>
              {{scope.row.houName}}
              <br>
              {{scope.row.clsTime}}
              <br>
              座位号：{{scope.row.seatNo}}
            </div>
            <!-- <div v-else>暂无</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="signPayType" label="支付方式"></el-table-column>
        <el-table-column prop="signPay" label="支付状态">
          <template slot-scope="scope">
            {{scope.row.strPay}}
            <br>
            {{scope.row.strExamine}}
          </template>
        </el-table-column>
        <el-table-column prop="opera" label="操作">
          <template slot-scope="scope">
            <div>
              <el-button v-if="scope.row.needPay==1" type="text" @click="toPay(scope.row.id)">支付</el-button>
            </div>
            <div>
              <el-button type="text" v-if="scope.row.needDownload==1" @click="toDown(scope.row.id)">下载准考证</el-button>
            </div>
            <div>
              <el-button type="text" v-if="scope.row.needChooseSeat==1" @click="toSeat(scope.row.id)">选座位</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          @current-change="pageChange"
          :page-size="params.pageSize"
          layout="prev, pager, next, jumper"
          :total="tableList.totalCount"
        ></el-pagination>
        <PayDialog
          :signId="paySignId"
          :visible="payVisible"
          @payCancel="payCancel"
          @payDone="payDone"
        ></PayDialog>
      </div>
    </div>
  </div>
</template>
<script>
import { getTimeChange } from '@/utils/filter'
import PayDialog from "@/components/PayDialog.vue";
export default {
  components: {
    PayDialog
  },
  data() {
    return {
      payVisible: false,
      paySignId: "",
      signIds:'',
      activeName1: "first",
      tableList: {
        // data: [],
        totalCount: 0,
        // subName:'',
      },
      tableData:[],
      params: {
        pageNo: 1,
        pageSize: 10,
        pay: "",
        status: 1
      }
    };
  },
  created() {
    console.log(localStorage.getItem("token"));
    this.getList();
  },
  methods: {
    toPay(signId) {
      let that = this;
      that.paySignId = signId;
      that.payVisible = true;
    },
    toDown(signId){
      console.log(signId)
      let that = this;
      // window.Global.get('/sign/export/admission?id='+signId, null, rs => {
      //   console.log("'/sign/export/admission?id='+signId",'/sign/export/admission?id='+signId)
      //   const url = window.URL.createObjectURL(new Blob([rs.data],{type: 'application/octet-stream;charset=utf-8'}));
      //     const link = document.createElement('a');
      //     let fname = '准考证.pdf';
      //     link.href = url;
      //     link.setAttribute('download', fname);
      //     document.body.appendChild(link);
      //     link.click();
      //   that.$message.success({
      //     message: "下载成功",
      //   });
      // });
      let data = {
        id:signId
      }
      window.open(window.Global.domain+'/sign/export/admission?id='+signId);
      // window.Global.get('/sign/export/admission', data, rs => {
      //     const url = window.Global.domain+'/sign/export/admission?id='+signId;
      //     // console.log(url) 
      // })
      
    },
    toSeat(signId){
      console.log(signId)
      sessionStorage.setItem('signId',signId)
      console.log(sessionStorage.getItem('signId'))
      this.$router.push({name:"indexSeat"})
    },
    payCancel() {
      let that = this;
      that.payVisible = false;
      that.getList();
    },
    payDone() {
      let that = this;
      that.payVisible = false;
      that.getList();
    },
    getList() {
      let me = this;
      console.log(11111112111111)
      window.Global.get("/sign/info", me.params, rs => {
        console.log(rs.data.result.data);
        if (rs.data.status == 200) {
          me.tableList= rs.data.result
          console.log(22222222222,me.tableData)
          me.tableData = rs.data.result.data.map((item)=>{
            // console.log(item.clsTime.Substring(1,2))
            // console.log(getTimeChange(item.clsTime))
            item.clsTime = getTimeChange(item.clsTime);
            return {
              ...item   //结构赋值
            }
          })
          console.log(22222222222,me.tableData)
        } else {
        }
      });
    },
    handleTypeChange(tab, event) {
      let that = this;
      console.log("tab.index", tab.index);
      switch (tab.index) {
        case "0":
          that.params.pay = "";
          break;
        case "1":
          that.params.pay = 0;
          break;
        case "2":
          that.params.pay = 1;
          break;
      }
      that.params.pageNo = 1;
      that.getList();
    },
    pageChange(page) {
      console.log("page", page);
      let that = this;
      that.params.pageNo = page;
      that.getList();
    },
    downFill(){
        this.$emit("downFill","false")
      }
  }
};
</script>

<style lang="less">
@import "../../static/less/tutorial.less";
</style>


// WEBPACK FOOTER //
// src/components/Enter.vue